import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  listReview: null,
  detailReview: null,
  settingsReview: null,
  statisticBar: null,
  statisticRating: null,
  dataEmail: null,
  dataCountTotal: 0,
  dataCountTotalResult: 0,
  dataCountTotalNotPublish: 0,
  dataCountTotalReview: 0,
  checkAction: false,
});

const reviewReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.GET_LIST_REVIEW_RESULT:
      return state
        .set("listReview", action.payload.list_product_reviews)
        .set("dataCountTotalReview", action.payload.count_total_reviews)
        .set("dataCountTotalResult", action.payload.count_total_result)
        .set(
          "dataCountTotalNotPublish",
          action.payload.count_total_not_public_reviews,
        );

    case types.GET_DETAIL_REVIEW_RESULT:
      return state.set("detailReview", action.payload.res);

    case types.GET_SETTINGS_RESULT:
      return state.set("settingsReview", action.payload);

    case types.GET_STATISTIC_BAR_RESULT:
      return state.set("statisticBar", action.payload);

    case types.GET_STATISTIC_RATING_RESULT:
      return state.set("statisticRating", action.payload);

    case types.GET_LIST_LOG_EMAIL_RESULT:
      return state.set("dataEmail", action.payload);

    case types.GET_STATISTIC_COUNT_TOTAL_RESULT:
      return state.set("dataCountTotal", action.payload);

    case types.CHANGE_STATUS_REVIEW_RESULT:
      return state.set("checkAction", !state.get("checkAction"));

    case types.DELETE_MULTI_REVIEW_RESULT:
      return state.set("checkAction", !state.get("checkAction"));

    case types.DELETE_REVIEW_RESULT:
      return state.set("checkAction", !state.get("checkAction"));

    default:
      return state;
  }
};

export default reviewReducer;
